module.exports = __webpack_public_path__ + "img/www.bbb.org.0b62bf2b.png";